module.exports = __webpack_public_path__ + "static/media/map-blue.608c674e.svg";